import { QueryClientProvider } from './query-client.provider';
import { AntConfigProvider } from './ant-config.provider';

export function AppProviders({ children }: { children?: React.ReactNode }) {
  return (
    <QueryClientProvider>
      <AntConfigProvider>{children}</AntConfigProvider>
    </QueryClientProvider>
  );
}
